<div fxLayout="column" class="page-container">
  <div class="top-image">
    <img ngSrc="assets/branding/top-traces2.png" alt="Top Traces" height="500" width="643" priority decoding="async">
  </div>
  <div fxLayout="column" class="sign-up-container" fxLayoutAlign="center center">
    <form [formGroup]="signupData">
      <div class="input-container">
        <h1>Ready to play?</h1>
        <div *ngIf="config$ | async as config">
          <p *ngIf="config.usernameMessageEnabled">{{config.usernameMessage}}</p>
        </div>
        <eon-ui-input formControlName="userInput" placeholder="Create your username"></eon-ui-input>
        <eon-ui-form-message type="error" [message]="changeError()" [hidden]="!hasError()" scheme="white"></eon-ui-form-message>
      </div>
      <div fxLayout=column fxLayoutGap=15px class="button-container">
        <eon-ui-button  fullWidth=true text="Continue"  type=text (click)="confirm()" [disabled]="isEnabled()" scheme="white"></eon-ui-button>
        <eon-ui-button  rank=secondary fullWidth=true text="Back"  type=text (click)="navigateBack()" scheme="white"></eon-ui-button>
      </div>
    </form>
  </div>
  <div class="bottom-image">
    <img ngSrc="assets/branding/bottom-traces3.png" alt="Bottom Traces" height="500" width="1401"  loading="eager" decoding="async">
  </div>
</div>

